export default {
	data() {
		return {
		}
	},
	methods: {
		/**
		 **@disc:定位到页面上未通过校验元素
		 **@params: element id
		 */
		locateToErrorElement(id) {
			$('.mainCon').scrollTop($('.mainCon').scrollTop() + $(`#${id}`).offset().top
				- $('.mainCon').offset().top - 100);
		},
	}
}




// WEBPACK FOOTER //
// ./src/mixins/locateToErrorElement.js